export default {
    type: 'service-categories',
    aliases: {
        camel: 'serviceCategories',
        singular: 'Service category',
        plural: 'Service categories',
        lowerSingular: 'service category',
        lowerPlural: 'service categories',
    },
    relations: {},
    publishable: true,
    adminSection: 'services',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerServiceCategoryRecord',
            loader: () => import('./AdministerServiceCategoryRecord')
        },
    },
};
